module.exports = __webpack_public_path__ + "static/media/referral_mobile2.2b0941c9.PNG";